module.exports = __webpack_public_path__ + "static/media/virtualsport.290e143e.png";